export var bodyFontThemes = {sourceSans:'c5-19-3_odhvdm1',notoSerif:'c5-19-3_odhvdm2',lato:'c5-19-3_odhvdm3',montserrat:'c5-19-3_odhvdm4',openSans:'c5-19-3_odhvdm5',raleway:'c5-19-3_odhvdm6'};
export var bodyFontVars = {fontFamily:'var(--c5-19-3_odhvdm0)'};
export var defaultBodyFontFamily = 'Inter';